import React, { useState } from 'react';
import Recipedetail from './Recipedetail';
// import '../App.css';
import '../style/recipe.css';

function Recipe(props) {
    let[show,setShow] = useState(false);
    // function Recipe({rec}){
    // console.log(rec);
    console.log("Recipe",props.rec.recipe);
    //  const {label,image,url,ingredients} = rec.recipe;
    const {label,image,url,ingredients} = props.rec.recipe;
     
    return (
    <>
    <div className="recipes">
           <h2> {label}  </h2>
          <img src={image} alt={label}></img>
          <br/>
          <a href={url} target='_blank' rel='noopener noreferrer'>URL</a>
          <br/>
          <button onClick={()=>{setShow(!show)}}>Ingrdients</button>
          {show && <Recipedetail ingredient={ingredients}></Recipedetail>} 
          
    </div>      
    </>
    );
}

export default Recipe;